import { forwardRef } from 'react'
import { useDispatch } from 'react-redux'
import * as SnackbarActions from '../../../../../global/snackbar/snackbar.actions'
import { type ModalInterface } from 'components'
import { useSubmitLiveblocksFeedback } from '@global/hooks/mutations/admin'
import { Feedback } from '@components/modals/feedback'
import { t } from '@lingui/core/macro'
import { FeedbackSubmissionRequest } from '@taxonomy-translation/types'

export const FeedbackModal = forwardRef<ModalInterface>((_, ref) => {
  const dispatch = useDispatch()

  const { mutateAsync } = useSubmitLiveblocksFeedback()

  const handleSubmit = async (values: FeedbackSubmissionRequest) => {
    try {
      await mutateAsync(values)
      dispatch(
        SnackbarActions.showSnackbar({
          message: t`Thank you for your feedback!`,
          type: 'SUCCESS',
          duration: 5000,
        }),
      )
    } catch {
      dispatch(
        SnackbarActions.showSnackbar({
          message: t`Something went wrong`,
          type: 'ERROR',
          duration: 5000,
        }),
      )
    }
  }

  return (
    <Feedback
      onSubmit={handleSubmit}
      ref={ref}
      subtitle={t`How is your experience using the new comment side panel?`}
    />
  )
})

FeedbackModal.displayName = 'FeedbackModal'
